import { DimensionsOfImageWithBorder } from "./types";

export const TRANSFORM_FOLDER_NAME = "transform";

export const FORMAT_75x100: DimensionsOfImageWithBorder = {
  width: 75,
  height: 100,
  border: 5,
};
export const FORMAT_100x135: DimensionsOfImageWithBorder = {
  width: 100,
  height: 135,
  border: 5,
};

export const MAX_NUM_PHOTOS = 50;

export const STATE_INPUT = 0;
export const STATE_UPLOADING = 1;
export const STATE_TRANSFORMING = 2;
export const STATE_DONE = 3;
export const STATE_ERROR = 4;
